import { Inmate } from '@reliance/types/models/Inmate';
import { IAuthToken } from '../models/auth';
import { ApiSuccessResponse, IApiService, IPaginatedResponse } from '../services/api_service';
import config from '../services/config';

export const inmates = (siteApi: IApiService, centralApi: IApiService, getAuthToken: () => IAuthToken) => ({
  index: (params = ({} = null)): Promise<IPaginatedResponse<Inmate>> => {
    return siteApi.get('/inmate', { params: { ...params, preferCache: false } });
  },
  indexCentral: (params = ({} = null)): Promise<IPaginatedResponse<Inmate>> => {
    return centralApi.get('/inmate', { params: { ...params } });
  },
  get: function (id, params?): Promise<Inmate> {
    return siteApi.get(`/inmate/${id}`, { params });
  },
  post: function (data) {
    return siteApi.post('/inmate', data);
  },
  put: function (id, changes) {
    return siteApi.put(`/inmate/${id}`, changes);
  },
  delete: function (id, amount, note?) {
    return siteApi.delete(`/inmate/${id}`, { data: { amount, note } });
  },
  photoUrl: function (id) {
    return `${config.api.url}/inmate/photo/${id}?token=${getAuthToken().accessToken}&r=${new Date()}`;
  },
  pin: function () {
    return siteApi.get('/inmate/pin');
  },
  postMerge: (fromInmateId: number, toInmateId: number): Promise<ApiSuccessResponse<void>> => {
    return centralApi.post('/inmate/merge', { fromInmateId, toInmateId });
  }
});
